export const trackEvent = (name, params = {}) => {
  if (window.gtag && window.GA_MEASUREMENT_ID) {
    window.gtag('event', name, { ...params, transport_type: 'beacon' });
  }
};
